import { motion } from "framer-motion";
import { TrendingUp, Lightbulb, Sprout } from "lucide-react";

const PILLARS = [
  {
    icon: TrendingUp,
    title: "Strategic Funding",
    desc: "From debt to equity, project finance to bridge deals — we structure capital that fits the ambition of your business.",
  },
  {
    icon: Lightbulb,
    title: "Smart Solutions",
    desc: "Advisory you can act on. We combine investor network depth with operating-side experience to solve the hard problems.",
  },
  {
    icon: Sprout,
    title: "Sustainable Growth",
    desc: "We back companies for the long arc — through funding, FMCG brand building, and market expansion.",
  },
];

export default function AboutPillars() {
  return (
    <section
      id="about"
      data-testid="about-pillars-section"
      className="relative bg-[#FAFAF7] py-24 md:py-32"
    >
      <div className="cgp-container">
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.7 }}
          className="max-w-3xl"
        >
          <span className="cgp-overline" data-testid="about-overline">
            Who We Are
          </span>
          <h2
            data-testid="about-headline"
            className="font-serif text-[#0A1F44] text-4xl sm:text-5xl lg:text-6xl font-light tracking-tight mt-6 leading-[1.05]"
          >
            One firm. Two engines.
            <br />
            <span className="italic text-[#0A1F44]/70">
              Capital advisory &amp; FMCG brand building.
            </span>
          </h2>
          <p className="mt-8 text-[#0B1A36]/75 text-lg leading-relaxed max-w-2xl">
            Catalyst Global Partners is a boutique advisory and holding group
            committed to fueling growth and creating value — for businesses
            seeking capital, and for consumer brands seeking scale.
          </p>
        </motion.div>

        <div className="mt-20 grid grid-cols-1 md:grid-cols-3 gap-8 md:gap-12">
          {PILLARS.map((p, i) => (
            <motion.div
              key={p.title}
              initial={{ opacity: 0, y: 28 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.6, delay: i * 0.08 }}
              data-testid={`pillar-card-${i}`}
              className="group"
            >
              <div className="flex items-center justify-center w-14 h-14 rounded-full border border-[#C8A24A]/40 bg-white text-[#C8A24A] mb-7">
                <p.icon size={22} strokeWidth={1.6} />
              </div>
              <h3 className="font-serif text-2xl text-[#0A1F44]">{p.title}</h3>
              <span className="cgp-gold-rule mt-4" />
              <p className="text-[#0B1A36]/70 mt-5 leading-relaxed">{p.desc}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
